import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选推荐</h2>
            <p className="mt-2 text-sm text-foreground-500">编辑精选，品质之选</p>
          </div>
          <a href="#ranking" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            更多推荐 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.slice(0, 7).map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentNode as HTMLElement)?.classList.add('bg-background-200');
                  }}
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/90 text-foreground-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-2.5 right-2.5">
                  <span className="flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[11px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
                    <i className="ri-star-fill text-[9px]"></i> {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}